import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

export interface FixOptionsProps<T extends { id: string }> {
  direction?: "vertical" | "horizontal";
  options: Array<T>;
  renderer: (item: T) => React.ReactNode;
  active?: string | null;
  onUpdateActive?: (id: string) => void;
  part?: string;
}

export function FixOptions<T extends { id: string }>({
  direction = "vertical",
  options,
  renderer,
  active = null,
  onUpdateActive,
  part,
}: FixOptionsProps<T>) {
  if (!options) return null;

  return (
    <div
      className={classNames(styles.root, styles[direction])}
      part={part}
      data-direction={direction}
    >
      {options.map((item) => (
        <button
          key={item.id}
          className={classNames(styles.option, {
            [styles.active]: item.id === active,
          })}
          onClick={() => onUpdateActive?.(item.id)}
          type="button"
        >
          {renderer(item)}
        </button>
      ))}
    </div>
  );
}

export default FixOptions;

